import React, { Component } from "react";
import { connect } from "react-redux";
import { resetLoginData } from "../../redux/features/loginSlice";
import { tempColorSetup } from "./SiteColorCode";
import TryAgain from "../TryAgain";
import SplashPage from "./SplashPage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isCssLoaded: false, isCssLoading: true, comp: null };
    
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  componentDidMount() {
    const { companyNumber } = this.props;
    const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;

    fetch(`${API_HOST_LOGIN}/setup/clientConfig/key/siteUrlCompanyMapping`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Data fetched successfully:", data, companyNumber);
        if (!window.location.host.includes("localhost")) {
          let existingKey = null;
          if (companyNumber) {
            existingKey = Object.keys(data).find((value) =>
              value.includes(companyNumber)
            );
          }

          let compNumber = null;

          if (existingKey && window.location.host === data[existingKey]) {
            compNumber = companyNumber;
          } else {
            const companyNumberItem = Object.entries(data).find(
              (value) => value[1] === window.location.host
            );
            if (companyNumberItem) {
              compNumber = companyNumberItem[0].split("-")[0];
            }
          }

          if (compNumber) {
            // Dynamically import CSS based on the comp number

            import(`../../assets/style.css`)
              .then(() => {
                if (compNumber.trim() == 1326) {
                  import(
                    `../../assets/${compNumber.trim()}/images/main-logo.png`
                  ).then((logo) => {
                    document.documentElement.style.setProperty(
                      "--main-site-logo",
                      `url(${logo.default})`
                    );
                  });
                } else {
                  import(
                    `../../assets/${compNumber.trim()}/images/main-logo.svg`
                  ).then((logo) => {
                    document.documentElement.style.setProperty(
                      "--main-site-logo",
                      `url(${logo.default})`
                    );
                  });
                }
                import(
                  `../../assets/${compNumber.trim()}/images/banner.png`
                ).then((banner) => {
                  document.documentElement.style.setProperty(
                    "--main-site-banner",
                    `url(${banner.default})`
                  );
                });
                import(
                  `../../assets/${compNumber.trim()}/images/sso-image.png`
                ).then((sso) => {
                  document.documentElement.style.setProperty(
                    "--main-site-sso-logo",
                    `url(${sso.default})`
                  );
                });
                document.documentElement.style.setProperty(
                  "--main-site-color",
                  tempColorSetup[compNumber.trim()].mainColor
                );
                document.documentElement.style.setProperty(
                  "--main-site-hover-color",
                  `${tempColorSetup[compNumber.trim()].hoverColor}`
                );
                setTimeout(() => {
                  var logo = document.getElementById("logo");
                  if (logo && tempColorSetup[compNumber.trim()].logoStyle) {
                    logo.style.cssText =
                      tempColorSetup[compNumber.trim()].logoStyle;
                  }
                }, 500);
                this.setState({
                  isCssLoaded: true,
                  isCssLoading: false,
                  comp: compNumber,
                });
              })
              .catch((error) => {
                console.error("Error loading CSS:", error);
                this.setState({ isCssLoaded: false, isCssLoading: false });
              });
          } else {
            // Handle the case when comp number is not available
            this.setState({ isCssLoaded: false, isCssLoading: false });
          }
        } else {
          // Use "compNumber" 1287 for localhost
          const localhostCompNumber = "1287";
          document.documentElement.style.setProperty(
            "--main-site-color",
            tempColorSetup[localhostCompNumber].mainColor
          );
          document.documentElement.style.setProperty(
            "--main-site-hover-color",
            `${tempColorSetup[localhostCompNumber].hoverColor}`
          );
          import(`../../assets/style.css`)
            .then(() => {
              if (localhostCompNumber.trim() == 1326) {
                import(
                  `../../assets/${localhostCompNumber}/images/main-logo.png`
                ).then((logo) => {
                  document.documentElement.style.setProperty(
                    "--main-site-logo",
                    `url(${logo.default})`
                  );
                });
              } else {
                import(
                  `../../assets/${localhostCompNumber}/images/main-logo.svg`
                ).then((logo) => {
                  document.documentElement.style.setProperty(
                    "--main-site-logo",
                    `url(${logo.default})`
                  );
                });
              }
              import(
                `../../assets/${localhostCompNumber}/images/banner.png`
              ).then((banner) => {
                document.documentElement.style.setProperty(
                  "--main-site-banner",
                  `url(${banner.default})`
                );
              });
              import(
                `../../assets/${localhostCompNumber}/images/sso-image.png`
              ).then((sso) => {
                document.documentElement.style.setProperty(
                  "--main-site-sso-logo",
                  `url(${sso.default})`
                );
              });
              setTimeout(() => {
                var logo = document.getElementById("logo");
                if (logo && tempColorSetup[localhostCompNumber].logoStyle) {
                  logo.style.cssText =
                    tempColorSetup[localhostCompNumber].logoStyle;
                }
              }, 500);

              this.setState({
                isCssLoaded: true,
                isCssLoading: false,
                comp: localhostCompNumber,
              });
            })
            .catch((error) => {
              console.error("Error loading CSS for localhost:", error);
              this.setState({ isCssLoaded: false, isCssLoading: false });
            });
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        this.setState({ isCssLoaded: false, isCssLoading: false });
      });
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //   logErrorToMyService(error, errorInfo);
    //   if(error) {

    //   }
    this.setState({ hasError: true });
    // this.props.resetLoginData();
    // window.location.replace("/");
    //Minified React error

    // api call to catch error start
    const { companyNumber, username, token } = this.props;
    const apiUrl = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}/saveErrorDetail`;

    const errorDetailPayload = {
      errorDetailPage: window.location.pathname.substring(1),
      // errorDetailUrl: "",
      errorDetailUrl: window.location.href,
      // errorDetailPayload: "",
      errorDetailPayload: { errorInfo: errorInfo.componentStack },
      errorDetailResponse: { error: error },
      userName: username,
      companyNumber: companyNumber,
      recordType: "React Error",
    };

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: process.env.REACT_APP_Auth_token,
      },
      body: JSON.stringify(errorDetailPayload),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Error detail saved successfully:", data);
      })
      .catch((fetchError) => {
        console.error("Failed to save error detail:", fetchError);
      });

    // api call to catch error start

    if (error?.message.includes("Minified React error")) {
      window.location.reload(true);
    }
    console.log(errorInfo, "***", error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "3rem" }}>Something went wrong.</h1>
          <p style={{ fontSize: "1.5rem" }}>
            We apologize for the inconvenience. Our team has been notified and
            will work to resolve the issue as soon as possible.
          </p>
          <p style={{ fontSize: "1.5rem" }}>
            Please try refreshing the page or check back later.
          </p>
          <TryAgain></TryAgain>
        </div>
      );
    }

    // Show splash page only when CSS loading has failed (not during loading)
    if (!this.state.isCssLoading && !this.state.isCssLoaded) {
      return <SplashPage />;
    }

    // Show children when CSS is loaded, or null during loading
    return this.state.isCssLoaded ? this.props.children : null;
  }
}
function mapStateToProps(state) {
  const { login } = state;
  const username = login?.userInfoAttr?.userInfo?.username || "";
  const token = login?.token || "";
  return {
    companyNumber: login?.companyNumber || "",
    username: username,
    token: token,
  };
}
export default connect(mapStateToProps, { resetLoginData })(ErrorBoundary);
